/** @todo incorporate ninedots roles, and refactor codebase to use this util */
export default ({ role }) => ['admin', 'districtAdmin'].includes(role)
